import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { h } from 'vue';
import * as ElementPlusIcons from '@element-plus/icons-vue';
const SequenceLine = {
  props: ['label', 'ids', 'iconFor', 'tone'],
  render() {
    return h('div', {
      class: ['sequence-line', this.tone]
    }, [h('span', {
      class: 'sequence-label'
    }, this.label), this.ids?.length ? h('div', {
      class: 'sequence-items'
    }, this.ids.map((id, index) => h('div', {
      class: 'sequence-item',
      key: `${this.label}_${id}_${index}`
    }, [h('span', {
      class: 'sequence-index'
    }, String(index + 1)), h(this.iconFor(id))]))) : h('span', {
      class: 'empty-answer'
    }, '未作答')]);
  }
};
export default {
  name: 'ImageSequenceMemoryRender',
  components: {
    SequenceLine
  },
  emits: ['answer'],
  props: {
    data: {
      type: Object,
      required: true
    },
    difficulty: {
      type: Object,
      default: () => ({})
    },
    review: {
      type: Object,
      default: null
    },
    reviewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      phase: this.reviewMode ? 'answering' : 'ready',
      activeAssetId: null,
      selectedIds: [],
      timers: [],
      playToken: 0
    };
  },
  computed: {
    readyMs() {
      return this.durationValue('readyMs', 500);
    },
    flashMs() {
      return this.durationValue('flashMs', 500);
    },
    gapMs() {
      return this.durationValue('gapMs', 150);
    },
    phaseTitle() {
      if (this.phase === 'playing') return '记住闪烁顺序';
      if (this.phase === 'answering') return this.reviewMode ? '答题回看' : '现在请作答';
      return '准备观察图形';
    },
    instruction() {
      if (this.phase === 'playing') return '请集中注意当前闪烁的图形';
      if (this.phase === 'answering') return this.reviewMode ? '可重新播放本题闪烁过程' : '闪烁已结束，请在下方按顺序点击';
      return '九个图形即将开始依次闪烁';
    },
    correctIds() {
      return this.parseIds(this.data.rightAnswer);
    },
    reviewIds() {
      return this.parseIds(this.review?.answer);
    }
  },
  watch: {
    'data.questionIndex'() {
      this.resetQuestion();
    }
  },
  mounted() {
    if (this.reviewMode) {
      this.selectedIds = this.reviewIds;
    } else {
      this.startPlayback();
    }
  },
  beforeUnmount() {
    this.cancelTimers();
  },
  methods: {
    iconFor(assetId) {
      return ElementPlusIcons[assetId] || ElementPlusIcons.Picture;
    },
    durationValue(key, fallback) {
      const value = Number(this.difficulty?.[key]);
      return Number.isFinite(value) && value >= 0 ? value : fallback;
    },
    parseIds(value) {
      return value ? value.split(',').map(item => item.trim()).filter(Boolean) : [];
    },
    resetQuestion() {
      this.selectedIds = [];
      this.$emit('answer', null);
      if (this.reviewMode) {
        this.phase = 'answering';
        this.selectedIds = this.reviewIds;
      } else {
        this.startPlayback();
      }
    },
    cancelTimers() {
      this.timers.forEach(timer => window.clearTimeout(timer));
      this.timers = [];
      this.playToken += 1;
    },
    wait(ms, token) {
      return new Promise(resolve => {
        const timer = window.setTimeout(() => resolve(token === this.playToken), ms);
        this.timers.push(timer);
      });
    },
    async startPlayback() {
      this.cancelTimers();
      const token = this.playToken;
      this.phase = 'ready';
      this.activeAssetId = null;
      if (!(await this.wait(this.readyMs, token))) return;
      this.phase = 'playing';
      for (const assetId of this.data.flashSequence) {
        this.activeAssetId = assetId;
        if (!(await this.wait(this.flashMs, token))) return;
        this.activeAssetId = null;
        if (!(await this.wait(this.gapMs, token))) return;
      }
      this.phase = 'answering';
    },
    selectAsset(assetId) {
      if (this.phase !== 'answering' || this.selectedIds.includes(assetId)) return;
      this.selectedIds.push(assetId);
      this.$emit('answer', this.selectedIds.length === this.data.memoryCount ? this.selectedIds.join(',') : null);
    },
    clearAnswer() {
      this.selectedIds = [];
      this.$emit('answer', null);
    }
  }
};